import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DiffService, FieldDiffResult } from '../../services/diff/diff.service';

@Component({
  standalone: false,
  selector: 'irembogov-field-diff-viewer',
  templateUrl: './irembogov-field-diff-viewer.component.html',
  styleUrls: ['./irembogov-field-diff-viewer.component.scss'],
})
export class IrembogovFieldDiffViewerComponent implements OnChanges {
  @Input() oldData: Record<string, unknown> = {};
  @Input() newData: Record<string, unknown> = {};
  @Input() fieldLabels: Record<string, string> = {};
  @Input() showUnchanged = false;
  @Input() sectionTitle = '';

  fieldDiffs: FieldDiffResult[] = [];
  changedCount = 0;

  constructor(private readonly diffService: DiffService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['oldData'] || changes['newData']) {
      this.computeFieldDiffs();
    }
  }

  computeFieldDiffs(): void {
    this.fieldDiffs = this.diffService.compareFields(
      this.oldData ?? {},
      this.newData ?? {}
    );
    this.changedCount = this.fieldDiffs.filter(
      f => f.changeType !== 'unchanged'
    ).length;
  }

  getFieldLabel(field: FieldDiffResult): string {
    return this.fieldLabels[field.fieldPath] || field.fieldLabel;
  }

  formatValue(value: unknown): string {
    if (value === null || value === undefined) return '(empty)';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    return String(value as string | number | boolean);
  }

  getVisibleDiffs(): FieldDiffResult[] {
    if (this.showUnchanged) return this.fieldDiffs;
    return this.fieldDiffs.filter(f => f.changeType !== 'unchanged');
  }
}
